import { RefCallback, useCallback, useRef, useState } from 'react'

interface UseOverflowReturn {
  hasOverflow: boolean
  elementRef: RefCallback<HTMLDivElement>
}

const useOverflow = (): UseOverflowReturn => {
  const [hasOverflow, setHasOverflow] = useState(false)
  const elementRef = useRef<HTMLDivElement>(null)

  const refCallback: RefCallback<HTMLDivElement> = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        ;(elementRef as any).current = node
        const checkOverflow = () => {
          if (node) {
            const hasOverflow = node.scrollHeight > node.clientHeight
            setHasOverflow(hasOverflow)
          }
        }

        checkOverflow()

        const resizeObserver = new ResizeObserver(checkOverflow)
        resizeObserver?.observe(node)

        // Cleanup function will be called when ref changes
        return () => resizeObserver?.disconnect()
      }
    },
    []
  )

  return { hasOverflow, elementRef: refCallback }
}

export default useOverflow
